import type * as React from 'react';
import { post } from '@Domain/Api';
import type { BeneficiaryContactPayload } from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactsFetched';
import beneficiaryContactCreated, {
	type BeneficiaryContactCreatedAction,
} from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactCreated';
import beneficiaryContactCreationFailed, {
	type BeneficiaryContactCreationFailedAction,
} from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactCreationFailed';
import type CreateBeneficiaryContact from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Commands/CreateBeneficiaryContact';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = BeneficiaryContactCreatedAction | BeneficiaryContactCreationFailedAction;

export default (command: CreateBeneficiaryContact) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<BeneficiaryContactPayload>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/beneficiaries/${command.beneficiaryId}/contacts`,
				command.toJSON(),
			);

			const action = beneficiaryContactCreated(payload, command.beneficiaryId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryContactCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
